// extracted by mini-css-extract-plugin
export default {"main":"e4a1747b7e _5d1cc20272","xmark":"fc4e5c2f6e","fl_img":"b30dc68806 _3b5b880c8c"};